module.exports = __webpack_public_path__ + "img/icon-danger.0307a858.svg";